import { type SortDirection } from '@tanstack/react-table';
import { ColumnNameContainer, SortIconWrapper, StyledTableHeaderSorting } from './style';

type TableHeaderSortingProps = {
  children: React.ReactNode;
  isSorted: false | SortDirection;
  isSortable: boolean;
  onClick?: (event: unknown) => void;
  align?: 'left' | 'center' | 'right';
};

export const TableHeaderSorting = ({
  children,
  isSorted,
  isSortable,
  onClick,
  align = 'left',
}: TableHeaderSortingProps) => {
  return (
    <StyledTableHeaderSorting isSortable={isSortable} onClick={onClick} align={align}>
      {align === 'right' && isSortable && <SortIcon direction={isSorted} />}
      <ColumnNameContainer>{children}</ColumnNameContainer>
      {(align === 'left' || align === 'center') && isSortable && <SortIcon direction={isSorted} />}
    </StyledTableHeaderSorting>
  );
};

const SortIcon = ({ direction }: { direction: SortDirection | boolean }) => {
  if (direction === 'asc') {
    return (
      <SortIconWrapper>
        <Icon rotation={180} />
      </SortIconWrapper>
    );
  }

  if (direction === 'desc') {
    return (
      <SortIconWrapper>
        <Icon rotation={0} />
      </SortIconWrapper>
    );
  }

  return null;
};

const Icon = ({ rotation }: { rotation?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    transform={`rotate(${rotation ?? 0})`}
  >
    <path
      d="M11.9999 5.25C12.4141 5.25003 12.7499 5.58581 12.7499 6V16.1895L17.4697 11.4697C17.7626 11.1769 18.2373 11.1768 18.5302 11.4697C18.8231 11.7626 18.8231 12.2374 18.5302 12.5303L12.5302 18.5303C12.3896 18.6709 12.1988 18.75 11.9999 18.75C11.801 18.75 11.6103 18.6709 11.4697 18.5303L5.46967 12.5303C5.17678 12.2374 5.17678 11.7626 5.46967 11.4697C5.76257 11.1769 6.23733 11.1768 6.53022 11.4697L11.2499 16.1895V6C11.2499 5.58579 11.5857 5.25 11.9999 5.25Z"
      fill="#1E1E1E"
    />
  </svg>
);
